
import Shape from '@/assets/svg/icons/shape-even.svg';
import Vue from 'vue';
import { TransformedCmAccordion, TransformedCmTabs } from '~/transforms/transformModules';

export default Vue.extend({
  name: 'CmTabs',
  components: { Shape },
  data() {
    return {
      activeTabIndex: 0,
      width: 0,
    };
  },
  props: {
    data: {
      type: Object as () => TransformedCmTabs['data'],
      required: true,
    },
  },
  methods: {
    setActiveTabIndex(index: number): void {
      this.activeTabIndex = index;
    },
    getWindowWidth() {
      if (process.client) {
        this.width = window.innerWidth;
      }
    },
  },
  computed: {
    getAccordionData(): TransformedCmAccordion['data'] {
      return {
        headline: undefined,
        description: undefined,
        headlineSize: undefined,
        collapsibles: this.data.tabItems.map(item => ({
          headline: item.title,
          contentType: 'tabs',
          content: item,
        })),
        anchorId: this.data.anchorId,
      };
    },
  },
  mounted() {
    this.getWindowWidth();
    window.addEventListener('resize', this.getWindowWidth);
  },
  destroyed() {
    window.removeEventListener('resize', this.getWindowWidth);
  },
});
